import React, { useEffect, useState } from 'react';
import classes from "./AllQuizes.module.css";
import Header from '../components/Header';
import BottomNavbar from '../components/BottomNavbar';
import { IoGridSharp } from "react-icons/io5";
import { FaSearch, FaChevronRight } from "react-icons/fa";
import { getAllQuiz } from '../http/http';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaXmark, FaArrowLeft } from "react-icons/fa6";
import MediumLoader from '../components/Loaders/MediumLoader';
import { useTranslation } from 'react-i18next';
import { removeUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { imageBaseUrl } from '../utils/constants';
import SubLayout from '../components/SubLayout';

const AllQuizes = () => {
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const [quizes, setQuizes] = useState(null);
    const navigate = useNavigate();
    const [searching, setSearching] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const { selectedLanguage } = useSelector(state => state.languageSlice);
    const { t } = useTranslation();
    const dispatch=useDispatch();
    // useEffect(() => {
    //     window.scrollTo(0, 0);
    //   }, []);

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    useEffect(() => {
        if (searchText?.trim()?.length > 0) {
            setSearchResults(() => {
                return quizes.filter((quiz) =>
                    quiz?.name?.toLowerCase().includes(searchText.toLowerCase())
                );
            })
        }
        else {
            setSearchResults([]);
        }
    }, [searchText]);

    const fetchAllQuizes = async () => {
        try {
            setLoading(true);
            const response = await getAllQuiz(selectedLanguage, userToken);
            setQuizes(response?.data?.result);
            setLoading(false);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }

        }
    }

    useEffect(() => {
        if (userToken) {
            fetchAllQuizes();
        }
        else {
            navigate("/")
        }

    }, [selectedLanguage, userToken]);

    return (
        <>
            <Header />

            <div className={`${classes.container} ${classes.no_padding}`}>
                <div className={classes.icon_container} onClick={() => navigate(-1)} >
                    <FaArrowLeft className={classes.grid_icon} />
                </div>
                {searching ?
                    <input
                        type='text'
                        className={classes.search_input}
                        placeholder={t("6")}
                        onChange={handleSearchChange}
                        value={searchText}
                        autoFocus
                    />
                    :
                    <div className={classes.heading}>
                        <p className={classes.heading_text}>{t("7")}</p>
                    </div>

                }


                <div className={classes.search_button} onClick={() => {
                    setSearchResults([]);
                    setSearching((prevValue) => !prevValue);
                    setSearchText("");
                }}>
                    {searching ?
                        <FaXmark className={classes.search_icon} />
                        :
                        <FaSearch className={classes.search_icon} />
                    }
                </div>
            </div>

            <SubLayout>


            {/* <div className={classes.container}> */}
                <div className={classes.quizes_list}>
                    {
                        loading ? <MediumLoader /> :
                            (searchResults?.length > 0 ? searchResults : quizes)?.map((quiz, idx) => {
                                return (
                                    <div className={classes.quiz_item} key={idx} onClick={() => navigate("/quiz-details", {
                                        state: quiz
                                    })}>
                                        <div className={classes.quiz_image}>
                                            <img className={classes.quiz_img} src={quiz?.image ? `${imageBaseUrl}${quiz?.image}` : "/assets/images/download.png"} alt={quiz?.name} />
                                        </div>
                                        <div className={classes.quiz_description_container}>
                                            <p className={classes.quiz_name}>{quiz?.name}</p>
                                            <p className={classes.quiz_description}>{quiz?.description}</p>
                                        </div>
                                        <div className={classes.arrow_container}>
                                            <FaChevronRight className={classes.right_icon} />
                                        </div>
                                    </div>
                                )
                            })}
                </div>
            </SubLayout>

            {/* </div> */}
            <BottomNavbar active={1} />

        </>
    )
}

export default AllQuizes;